import startOfToday from 'date-fns/startOfToday';
import addYears from 'date-fns/addYears';
import addDays from 'date-fns/addDays';

export const minDate = addDays(startOfToday(), 1);
export const maxDate = addYears(minDate, 2);
